// extracted by mini-css-extract-plugin
export default {"container":"Window_container__P0iSf","header":"Window_header__WCPdY","content":"Window_content__shyet","topRightButtons":"Window_topRightButtons__75Hf5"};